import type { SxProps, Theme } from "@mui/material/styles";

export const buttonStyles: Record<string, SxProps<Theme>> = {
  btnModal: {
    display: "flex",
    justifyContent: "flex-end",
  },
};
